import Breadcrumb from "@/Components/Breadcrumb/Breadcrumb";
import Image from "next/image";
import React from "react";
import Card from "./Card";

import {
  TwitterShareButton,
  LinkedinShareButton,
  FacebookShareButton,
} from "react-share";

interface Props {
  data: any;
  block: any;
  bannerBlock: any;
}
const Banner: React.FC<Props> = ({ block, bannerBlock, data }) => {
  const blog = data;
  const url = process.env.NEXT_PUBLIC_REACT_APP_BASE_URL;

  return (
    <>
      <section className="request-proposal-banner bg-background-dark  py-[120px] lg:py-[150px] xl:pb-[240px]  relative z-0">
        {/* Shapes */}
        <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
          <Image
            src="/images/banner-left-layer-mobile.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-left-layer-tablet.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-left-layer-desktop.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden lg:block"
          />
        </div>
        <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
          <Image
            src="/images/banner-right-layer-mobile.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-right-layer-tablet.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-right-layer-desktop.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden lg:block"
          />
        </div>
        <div className="container relative z-20">
          <div>
            {data?.breadcrumbs?.item?.length > 0 && (
              <Breadcrumb
                items={data?.breadcrumbs?.item ?? []}
                className="mb-[16px] lg:mb-[32px] xl:mb-[40px] flex justify-center"
              />
            )}
            <div className="flex lg:flex-row flex-col justify-end items-start gap-6">
              <h1 className="text-white text-heading-2 font-extrabold uppercase md:text-start text-center">
                {bannerBlock.title}
              </h1>
              <div className="flex justify-end items-stretch gap-0 flex-[0_0_auto] md:mx-0 mx-auto">
                <div className="bg-gray-800 border-gray-500 border">
                  <p className="text-subtitle-2 font-regular text-white py-[15px] px-5">
                    Share On
                  </p>
                </div>
                <div className="bg-gray-800 border-gray-500 border flex justify-center items-center gap-5 py-[15px] px-5">
                  <LinkedinShareButton url={`${url}case-studies/${blog?.slug}`}>
                    <span>
                      <Image
                        src="/images/blog-linkedin.svg"
                        alt="linkedin"
                        width={24}
                        height={24}
                        className="object-cover w-[24px] h-[24px]"
                      />
                    </span>
                  </LinkedinShareButton>
                  <TwitterShareButton url={`${url}case-studies/${blog?.slug}`}>
                    <Image
                      src="/images/blog-twitter.svg"
                      alt="twitter"
                      width={24}
                      height={24}
                      className="object-cover w-[24px] h-[24px]"
                    />
                  </TwitterShareButton>
                  <FacebookShareButton url={`${url}case-studies/${blog?.slug}`}>
                    <Image
                      src="/images/blog-facebook.svg"
                      alt="facebook"
                      width={12}
                      height={24}
                      className="object-cover w-[12px] h-[24px]"
                    />
                  </FacebookShareButton>
                </div>
              </div>
            </div>
            {/* <p className="text-white text-[16px] xl:text-[18px] leading-[22px] xl:leading-[25.2px] font-normal text-center mt-4">
              {bannerBlock.description}
            </p> */}
          </div>
        </div>
        <div className="relative mb-[-120px] lg:mb-[-150px] xl:mb-[-240px]">
          <span className="absolute bottom-0 h-[calc(100%-120px)] lg:h-[calc(100%-150px)] xl:h-[calc(100%-240px)] mb-[-1px] w-full bg-white z-10 block"></span>
          <div className="relative z-20 container">
            <Card item={block} data={data} />
            <div className="mt-[80px] xl:container">
              <h2 className="text-heading-4 font-bold text-primary-text">
                {block?.title}
              </h2>
              <p className=" text-black text-subtitle-1 mt-[24px]">
                {block?.description}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Banner;
